<template>
  <div>
    <companies />
  </div>
</template>

<script>
import Companies from "@/views/Components/Admin/Companies";

export default {
  components: { companies: Companies },
};
</script>

<style></style>
